import { AutocompleteInputChangeReason, Stack } from "@mui/material";
import { BackPageButtonSearchParamName } from "components/buttons/BackPageButton/types";
import AutocompleteControl from "components/form/AutocompleteControl";
import ROUTES from "constants/routes";
import typography from "constants/typography.constants";
import qs from "qs";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { CompetencyMapInputs, CompetencyMapOption, CompetencyMapOptionList, ScenarioOption } from "../types";

interface TestingSourceControlProps {
  competencyMaps: CompetencyMapOptionList;
  competencyMapsLoading: boolean;
  scenarios: ScenarioOption[] | undefined;
  scenariosLoading: boolean;
  isEditing: boolean;
  type: "trial" | "examination";
}

const TestingSourceControl = ({
  competencyMaps,
  competencyMapsLoading,
  scenarios,
  scenariosLoading,
  isEditing,
  type,
}: TestingSourceControlProps) => {
  const { id: examinationOrTrialId } = useParams();
  const { reset, getValues, watch } = useFormContext<CompetencyMapInputs>();
  const sourceType = watch("testingSourceType") || "competencyMap";
  const competencyMap = watch("competencyMap");
  const scenario = watch("scenario");

  // const resetSource = (nextSourceType: TestingSourceType) => {
  //   reset({ ...getValues(), testingSourceType: nextSourceType, competencyMap: undefined, scenario: undefined });
  // };

  const clearSource = (reason: AutocompleteInputChangeReason, field: "competencyMap" | "scenario") => {
    if (reason === "clear") reset({ ...getValues(), [field]: undefined });
  };

  // const sourceOptions = [
  //   { value: "competencyMap", label: "Карта компетенций" },
  //   { value: "scenario", label: "Сценарий" },
  // ];

  return (
    <Stack spacing={1.5}>
      {/* // TODO: вернуть при интеграции */}
      {/* <RadioGroupControl
        name='testingSourceType'
        radioOptions={sourceOptions}
        row
        disabled={!isEditing}
        onChangeCallback={(onChange) => (_, value) => {
          onChange(value);
          resetSource(value as TestingSourceType);
        }}
      /> */}
      {sourceType === "competencyMap" ? (
        <AutocompleteControl<CompetencyMapOption>
          options={competencyMaps || []}
          name='competencyMap'
          optionName='title'
          label='Карта компетенций'
          labelLink={
            competencyMap?.id
              ? {
                  to: {
                    pathname: `/${ROUTES.COMPETENCE_MAPS}/view/${competencyMap.id}`,
                    search: qs.stringify({
                      [type === "examination"
                        ? BackPageButtonSearchParamName.EXAMINATION_ID
                        : BackPageButtonSearchParamName.TRIAL_ID]: examinationOrTrialId,
                    }),
                  },
                  text: typography.follow,
                }
              : undefined
          }
          disabled={!isEditing}
          loading={competencyMapsLoading}
          rules={{ required: true }}
          formatDataBeforeOnChange={(data) => (data ? { id: data.id, title: data.title } : data)}
          onInputChange={(_, __, reason) => clearSource(reason, "competencyMap")}
        />
      ) : (
        <AutocompleteControl<ScenarioOption>
          options={scenarios || []}
          name='scenario'
          optionName='title'
          label='Сценарий'
          labelLink={
            scenario?.id ? { to: `/${ROUTES.SCENARIOS}/view/${scenario.id}`, text: typography.follow } : undefined
          }
          disabled={!isEditing}
          loading={scenariosLoading}
          rules={{ required: true }}
          onInputChange={(_, __, reason) => clearSource(reason, "scenario")}
        />
      )}
    </Stack>
  );
};

export default TestingSourceControl;
